<template>
  <div
    v-if="videoComponent.user"
    :class="{
      'pushed': videoComponent.user.isMuted,
      'no-control': videoComponent.user.isSelf && (videoComponent.media.length < 1 || !!videoComponent.media[0].popOut),
      'one-control': videoComponent.media.length < 1 || !!videoComponent.media[0].popOut || videoComponent.user.isSelf,
      'two-controls': videoComponent.media.length > 0 && !!videoComponent.media[0].popOut && !videoComponent.user.isSelf}"
    class="videoControl d-none d-md-block">
    <span
      v-b-tooltip.hover.bottom
      :title="!videoComponent.user.isMuted ? $t('MEETING.MUTE') : $t('MEETING.MUTED')"
      :class=" { 'no-interaction': videoComponent.user.isMuted && !videoComponent.user.isSelf }"
      class="d-inline-block camera"
      @click="toogleMute(videoComponent.user)">
      <microphone-icon
        v-if="!videoComponent.user.isMuted"
        :size="size"
        class="top-control rounded-circle"/>
      <microphone-off-icon
        v-else
        :size="size"
        class="muted top-control rounded-circle"/>
    </span>
    <span
      v-b-tooltip.hover.bottom
      v-if="videoComponent.media.length > 0 && !videoComponent.media[0].popOut"
      :title="$t('MEETING.POPOUT')"
      class="d-inline-block popout"
      @click="$parent.$parent.openPopup(videoComponent)"
    >
      <pop-out-icon
        id="selfPop"
        :size="size"
        class="top-control rounded-circle"/>
    </span>
    <span
      v-b-tooltip.hover.bottom
      v-if="!videoComponent.user.isSelf"
      :title="$t('MEETING.OPEN_MORE_MEETING_CONTROLS')"
      :id="'popover-videoComponent' + randomMoreMenu"
      tabindex="0"
      class="d-inline-block more"
    >
      <dots-horizontal-icon
        :size="size"
        class="top-control rounded-circle"/>
    </span>
    <b-popover
      v-if="!videoComponent.user.isSelf"
      :target="'popover-videoComponent' + randomMoreMenu"
      :show.sync="pop"
      triggers="focus"
      placement="bottom">
      <ul class="list-unstyled setting-list">
        <li
          :class="{ disabled: $parent.$parent.$parent.$refs.sideBar.$refs.sideChat.isPrivateChatDisabled }"
          class="d-flex position-relative"
          style="height:32px; line-height: 32px; vertical-align: middle;"
          @click="startPrivateChat(videoComponent.user)">
          <message-icon
            :size="20"
            class="mr-2"/>
          {{ $t('MEETING.MENU_PARTICIPANT_CHAT') }}
        </li>
        <hr v-if="$parent.$parent.$parent.$refs.sideBar.$refs.sidePart.amImoderator && videoComponent.user.presence">
        <li
          v-if="$parent.$parent.$parent.$refs.sideBar.$refs.sidePart.amImoderator && videoComponent.user.presence"
          :class="{ disabled: videoComponent.user.presence.isModerator }"
          class="d-flex position-relative"
          style="height:32px; line-height: 32px; vertical-align: middle;"
          @click="$parent.$parent.$parent.makeModerator(videoComponent.user.id); pop=!pop">
          <moderator-make-icon
            :size="20"
            class="mr-2"/>
          {{ $t('MEETING.MAKE_MODERATOR') }}
        </li>
        <li
          v-if="$parent.$parent.$parent.meetingInfo.webinar && ($parent.$parent.$parent.$refs.sideBar.$refs.sidePart.amImoderator || $parent.$parent.$parent.metaUserInfo.id == videoComponent.user.id)"
          class="d-flex position-relative"
          style="height:32px; line-height: 32px; vertical-align: middle;"
          @click="$parent.$parent.$parent.$refs.sideBar.$refs.sidePart.moveToAudience(videoComponent.user.id)">
          <become-speaker-icon
            :rotate="180"
            class="mr-2"/>
          {{ $t('MEETING.RETURN_AUDIENCE') }}
        </li>
        <li
          v-if="!$parent.$parent.$parent.meetingInfo.webinar && $parent.$parent.$parent.$refs.sideBar.$refs.sidePart.amImoderator"
          :class="{ disabled: videoComponent.user.isMuted }"
          class="d-flex position-relative"
          style="height:32px; line-height: 32px; vertical-align: middle;"
          @click="$parent.$parent.$parent.blockUserMedia(videoComponent.user.id, true, false); pop=!pop">
          <microphone-off-icon
            :size="20"
            class="mr-2"/>
          {{ $t('MEETING.BLOCK_AUDIO') }}
        </li>
        <li
          v-if="!$parent.$parent.$parent.meetingInfo.webinar && $parent.$parent.$parent.$refs.sideBar.$refs.sidePart.amImoderator"
          :class="{ disabled: videoComponent.user.videoOff }"
          class="d-flex position-relative"
          style="height:32px; line-height: 32px; vertical-align: middle;"
          @click="$parent.$parent.$parent.blockUserMedia(videoComponent.user.id, false, true); pop=!pop">
          <video-off-icon
            :size="20"
            class="mr-2"/>
          {{ $t('MEETING.BLOCK_VIDEO') }}
        </li>
        <li
          v-if="$parent.$parent.$parent.$refs.sideBar.$refs.sidePart.canSeeWaitingList && videoComponent.user.presence"
          :class="{ disabled: videoComponent.user.presence.isModerator || $parent.$parent.$parent.$refs.sideBar.$refs.sidePart.canBypassWaiting(videoComponent.user) }"
          class="d-flex position-relative"
          style="height:32px; line-height: 32px; vertical-align: middle;"
          @click="$parent.$parent.$parent.$refs.sideBar.$refs.sidePart.moveToWait(videoComponent.user.id); pop=!pop">
          <waiting-room-icon
            :size="20"
            class="mr-2"/>
          {{ $t('MEETING.SEND_TO_WAITING') }}
        </li>
        <li
          v-if="$parent.$parent.$parent.$refs.sideBar.$refs.sidePart.amImoderator"
          class="d-flex position-relative"
          style="height:32px; line-height: 32px; vertical-align: middle;"
          @click="$parent.$parent.$parent.$refs.sideBar.$refs.sidePart.kickOff(videoComponent.user.id); pop=!pop">
          <kick-meeting-icon
            :size="20"
            class="mr-2"/>
          {{ $parent.$parent.$parent.meetingInfo.webinar ? $t('MEETING.REMOVE_FROM_WEBINAR') : $t('MEETING.REMOVE_FROM_MEETING') }}
        </li>
      </ul>
    </b-popover>
  </div>
</template>
<script>
import { isMobile } from "../../functions/browserDetails"
import {randomId} from "../../functions/globalMethods"
import { ref } from "@vue/composition-api"
import MicrophoneIcon from "icons/Microphone"
import MicrophoneOffIcon from "icons/MicrophoneOff"
import PopoutIcon from "../../icons/Popout"
import DotsHorizontalIcon from "icons/DotsHorizontal"
import MessageIcon from "icons/Message"
import ModeratorMakeIcon from "../../icons/ModeratorMake"
import VideoOffIcon from "icons/VideoOff"
import WaitingRoomIcon from "../../icons/WaitingRoom"
import KickMeetingIcon from "../../icons/KickMeeting"
import BecomeSpeakerIcon from "../../icons/BecomeSpeaker"
export default {
  name: 'VideoComponentControls',
  components : {
    'microphone-icon': MicrophoneIcon,
    'microphone-off-icon': MicrophoneOffIcon,
    'pop-out-icon': PopoutIcon,
    'dots-horizontal-icon': DotsHorizontalIcon,
    'message-icon': MessageIcon,
    'moderator-make-icon': ModeratorMakeIcon,
    'video-off-icon': VideoOffIcon,
    'waiting-room-icon': WaitingRoomIcon,
    'kick-meeting-icon': KickMeetingIcon,
    'become-speaker-icon': BecomeSpeakerIcon
  },
  props: {
    videoComponent: {
      type: Object,
      default: () => {
      }
    },
    meetingControls: {
      type: Object,
      default: () => {
      }
    },
    index: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 24
    }
  },
  setup(props, context) {
    const randomMoreMenu = ref(randomId())
    const pop = ref(false)
    function canFullScreen (index) {
      return !isMobile() && (document.fullscreenEnabled)
    }

    function makeFullScreen (index) {
      context.parent.$refs.bigVideo0[index].requestFullscreen()
    }

    function toogleMute(user) {
      if (user.isSelf) {
        props.meetingControls.mic = !props.meetingControls.mic
      } else if(context.parent.$parent.$parent.$refs.sideBar.$refs.sidePart.amImoderator && !user.isMuted){
        context.parent.$parent.$parent.blockUserMedia(user.id, true, false)
      }
    }

    function startPrivateChat(user) {
      context.parent.$parent.$parent.$refs.sideBar.$refs.sideChat.startPrivateChat(user)
      if(context.parent.$parent.$parent.$refs.sideBar.chat == false)
        context.parent.$parent.$parent.$refs.sideBar.toggleBar('chat')
      pop.value = !pop.value
    }

    return {
      isMobile,
      canFullScreen,
      makeFullScreen,
      toogleMute,
      startPrivateChat,
      pop,
      randomMoreMenu
    }
  }
}
</script>
<style scoped>
.muted { background-color:#ffffff; color:#e72113; display: inline-flex; opacity: 1!important;}
.muted:hover{ background-color: #ffffff}
.tooltip { top: 0; }
.disabled {
    pointer-events:none;
    opacity:0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoArea/VideoComponentControls.vue